import React, { useState } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

function ForgotPassword({ onBack }) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    try {
      await axios.post(`${API_BASE}/auth/forgot-password`, { email });
      setSuccess(true);
    } catch (err) {
      const errorMessage = err.response?.data?.error || 'Failed to send reset email. Please try again.';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>Esfincter</h1>
        <h2>Forgot Password</h2>
        
        {error && <div className="error-message">{error}</div>}
        
        {success ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ 
              background: 'rgba(76, 175, 80, 0.2)', 
              border: '1px solid #4caf50', 
              color: '#4caf50', 
              padding: '1rem', 
              borderRadius: '8px', 
              marginBottom: '1.5rem' 
            }}>
              <p style={{ margin: 0 }}>
                If that email exists, a password reset link has been sent. Please check your inbox.
              </p>
            </div>
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={onBack}
            >
              Back to Login
            </button>
          </div>
        ) : (
          <>
            <p style={{ color: '#999', marginBottom: '1.5rem', textAlign: 'center' }}>
              Enter your email address and we'll send you a link to reset your password.
            </p>
            
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                />
              </div>

              <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginTop: '1.5rem' }}>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </button>
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={onBack}
                  disabled={loading}
                >
                  Cancel
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;

